import { render } from "./AdminLogin.vue?vue&type=template&id=cf5536e2&ts=true"
import script from "./AdminLogin.vue?vue&type=script&lang=ts"
export * from "./AdminLogin.vue?vue&type=script&lang=ts"

import "./AdminLogin.vue?vue&type=style&index=0&id=cf5536e2&lang=scss"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__